import firebase, { db } from '../../config/firebaseConfig';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/fr';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import useSound from 'use-sound';
import { Card, Button, Form, Badge, Toast } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import {
  editTask,
  removeTask,
  toggleChecked,
  addColorPicker
} from '../../actions/taskActions';
import { useTransition } from 'transition-hook';
import childTaskAudio from '../../audio/task4.wav';

function Task({
  task,
  removeTask,
  toggleChecked,
  editTask,
  detail,
  addColorPicker,
  priority,
  priorityColor,
  category,
  categoryColor,
  rdvDate,
  rdvTime,
  completed,
  modalColorBcg,
  modalColorTitle,
  modalColorPara,
  modalColorSpan,
  modalColorStatutRep,
  boxColorBcg,
  boxTitleColor,
  isToday,
  isTimeOver,
  currentTime,
}) {
  const [show, setShow] = useState(false);
  const [showTask, setShowTask] = useState(false);
  const [showRemoveTask, setShowRemoveTask] = useState(false);
  const [showColorTask, setShowColorTask] = useState(false);
  const [showColorTaskTitle, setShowColorTaskTitle] = useState(false);
  const [onOff, setOnOff] = useState(true);
  const [disable, setDisable] = useState(true);
  const [isColorChanged, setIsColorChanged] = useState(false);

  // 🔊 SÉCURISATION DU SON SUR MOBILE : Ajout de l'option soundEnabled pour éviter le crash matériel
  const [playSoundC] = useSound(childTaskAudio, {
    volume: 0.7,
    soundEnabled: typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0) ? false : true
  });

  const { stage, shouldMount } = useTransition(onOff, 300);
  const [showToast, setShowToast] = useState(false);

  const [localRdvDate, setLocalRdvDate] = useState(task?.rdvDate || 'Aucun');
  const [localRdvTime, setLocalRdvTime] = useState(task?.rdvTime || '12:00');
  const [showCalendar, setShowCalendar] = useState(false);
  const [isCalendarClosed, setIsCalendarClosed] = useState(false);
  const [adresseSuggestions, setAdresseSuggestions] = useState([]);

  const didMountRef = useRef(false);
  const boxesRef = useRef([]);
  const titlesRef = useRef([]);

  const colorBcg = '#040101';
  const colorTitle = '#ffffff';
  const colorPara = '#1299ed';
  const colorSpan = '#e3e3e3';
  const colorStatutRep = '#ff5757';
  const colorBoxBcg = '#282858';
  const colorBoxTitle = '#ffffff';

  const limite = 25;
  moment.locale('fr');

  // Fonction pour mettre la première lettre en majuscule
  const capitaliserMois = (locale, date) => {
    // Récupère le format natif ex: "septembre 2026"
    const labelIdoine = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(date);
    // Retourne la chaîne avec la première lettre en majuscule
    return labelIdoine.charAt(0).toUpperCase() + labelIdoine.slice(1);
  };

  useEffect(() => {
    // 🟢 SI LE RENDEZ-VOUS A ÉTÉ EFFACÉ EN DIRECT :
    if (!task?.rdvDate || task.rdvDate.toLowerCase().trim() === 'aucun' || task.rdvDate === '') {
      setLocalRdvDate('Aucun');
      setLocalRdvTime('12:00');
      setShowCalendar(false);
    } else {
      // Sinon, on synchronise normalement avec les données Firebase
      setLocalRdvDate(task.rdvDate);
      setLocalRdvTime(task.rdvTime || '12:00');
    }
    // 🟢 AJOUT : Réinitialise et fait réapparaître les boutons à chaque ouverture/changement de carte
    setIsCalendarClosed(true);
  }, [task?.rdvDate, task?.rdvTime]);

  const [state, setState] = useState({
    task: task?.task || '',
    priority: task?.priority || '',
    priorityColor: task?.priorityColor || '',
    category: task?.category || '',
    categoryColor: task?.categoryColor || '',
    detail: task?.detail || 'Aucun',
    rdvDate: task?.rdvDate || 'Aucun',
    rdvTime: task?.rdvTime || '12:00',
    completed: task?.completed || false,
    modalColorBcg: task?.modalColorBcg || colorBcg,
    modalColorTitle: task?.modalColorTitle || colorTitle,
    modalColorPara: task?.modalColorPara || colorPara,
    modalColorSpan: task?.modalColorSpan || colorSpan,
    modalColorStatutRep: task?.modalColorStatutRep || colorStatutRep,
    boxColorBcg: task?.boxColorBcg || colorBoxBcg,
    boxTitleColor: task?.boxTitleColor || colorBoxTitle,
    isRecurrent: task?.isRecurrent || false,
    recurrenceType: task?.recurrenceType || '',
    lastResetMonth: task?.lastResetMonth || '',
    taskLocation: task?.location || ''
  });

  const toggleEditState = () => {
    setState(prev => ({
      ...prev,
      priority: prev.priority,
      priorityColor: prev.priorityColor,
      category: prev.category,
      categoryColor: prev.categoryColor,
      detail: prev.detail || 'Aucun',
      rdvDate: prev.rdvDate,
      rdvTime: prev.rdvTime || '',
      taskLocation: prev.location || '',
    }));
    setDisable(false);
  };

  useEffect(() => {
    if (didMountRef.current) {
      setState((prev) => {
        return {
          ...prev,
          modalColorBcg: task?.modalColorBcg ? task.modalColorBcg : colorBcg,
          modalColorTitle: task?.modalColorTitle
            ? task.modalColorTitle
            : colorTitle,
          modalColorPara: task?.modalColorPara ? task.modalColorPara : colorPara,
          modalColorSpan: task?.modalColorSpan ? task.modalColorSpan : colorSpan,
          modalColorStatutRep: task?.modalColorStatutRep
            ? task.modalColorStatutRep
            : colorStatutRep,
          boxColorBcg: task?.boxColorBcg || colorBoxBcg,
          boxTitleColor: task?.boxTitleColor || colorBoxTitle
        };
      });
    } else didMountRef.current = true;
  }, [task]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!show) {
        setState((prevState) => ({
          ...prevState,
          task: task?.task,
          detail: task?.detail || 'Aucun',
          priority: task?.priority || '',
          category: task?.category || '',
          isRecurrent: task?.isRecurrent || false,
          recurrenceType: task?.recurrenceType || '',
          lastResetMonth: task?.lastResetMonth || '',
          taskLocation: task?.location || ''
        }));

        setLocalRdvDate(task.rdvDate || 'Aucun');
        setLocalRdvTime(task.rdvTime || '12:00');
        setIsCalendarClosed(true);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [show, task]);

  const handleCheckToggle = () => {
    const nextCheckedStatus = !task.checked;
    const now = currentTime || new Date(); // ✨ Garantit que 'now' existe dans le scope de la fonction

    if (nextCheckedStatus && typeof playSoundC === 'function') {
      try { playSoundC(); } catch (e) { }
    }

    // 🎯 1. FORCE L'ANIMATION DE SORTIE IMMÉDIATE (La carte commence à disparaître visuellement)
    setOnOff(false);

    setTimeout(() => {
      // 2. Préparation des données à envoyer
      const completionData = {
        checked: nextCheckedStatus,
        completedAt: nextCheckedStatus ? now : null, // Enregistre la date si coché, ou efface si décoché
        touchedByUser: true
      };

      // 3. Envoi synchrone à Redux localement
      toggleChecked(task, completionData);

      // 4. Envoi à Firestore pour persistance sur le serveur
      db.collection('tasks')
        .doc(task.id)
        .update(completionData)
        .then(() => {
          setOnOff(true);
        })
        .catch((err) => {
          console.error("Erreur de mise à jour Firestore :", err);
          setOnOff(true);
        });
    }, 300);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (value.length <= limite) {
      setState(prev => ({
        ...prev,
        [id]: value
      }));
    }
    setDisable(false);
  };

  const handleChangeDetail = (e) => {
    setState(prev => ({
      ...prev,
      detail: e.target.value
    }));
    setDisable(false);
  };

  const handleChangeColorBox = () => { setShowColorTask(true); }
  const handleChangeColorTitle = () => { setShowColorTaskTitle(true); }

  const handleShow = (task) => {
    if (task?.checked) {
      setShow(false);
    } else {
      setShow(true);
      setDisable(true);
    }
  };

  const handleShowTask = () => { setShowTask(true); };
  const handleShowRemoveTask = () => { setShowRemoveTask(true); };

  const handleRemoveTask = (task) => {
    setOnOff(!onOff);
    setShowRemoveTask(false);
    setTimeout(() => {
      removeTask(task);
    }, 1000);
  };

  const handleClose = (event) => {
    if (event) {
      event.preventDefault();
      setTimeout(() => {
        setState({
          task: task.task,
          priority: task.priority,
          priorityColor: task.priorityColor,
          category: task.category,
          categoryColor: task.categoryColor,
          detail: task.detail,
          rdvDate: task.rdvDate,
          rdvTime: task.rdvTime,
          modalColorBcg: task.modalColorBcg || colorBcg,
          modalColorTitle: task.modalColorTitle || colorTitle,
          modalColorPara: task.modalColorPara || colorPara,
          modalColorSpan: task.modalColorSpan || colorSpan,
          modalColorStatutRep: task.modalColorStatutRep || colorStatutRep,
          boxColorBcg: task.boxColorBcg || colorBoxBcg,
          boxTitleColor: task.boxTitleColor || colorBoxTitle,
          isRecurrent: task.isRecurrent || false,
          recurrenceType: task.recurrenceType || '',
          lastResetMonth: task.lastResetMonth || '',
          taskLocation: task.location || ''
        });
      }, 500);
    }
    setShow(false);
    setShowTask(false);
    setShowRemoveTask(false);
    setShowColorTask(false);
    setShowColorTaskTitle(false);
    setIsColorChanged(false);
  };

  const handleSubmitColorPicker = async (e) => {
    await addColorPicker({
      ...task,
      modalColorBcg: state.modalColorBcg,
      modalColorTitle: state.modalColorTitle,
      modalColorPara: state.modalColorPara,
      modalColorSpan: state.modalColorSpan,
      modalColorStatutRep: state.modalColorStatutRep,
      boxColorBcg: state.boxColorBcg || null,
      boxTitleColor: state.boxTitleColor || null
    });
    setDisable(true);
  };

  const handleValidationShut = (event) => {
    handleClose();
    handleSubmitColorPicker();
  }

  const handleReportToTomorrow = () => {
    let baseDate = new Date();

    // Décodage de la date d'origine de la tâche
    if (task.rdvDate) {
      baseDate = task.rdvDate.toDate ? task.rdvDate.toDate() : new Date(task.rdvDate);
    }

    // On ajoute précisément 1 jour et on formate en texte français complet (ex: "vendredi 18 septembre 2026")
    const tomorrowFrenchText = moment(baseDate).locale('fr').add(1, 'days').format('dddd D MMMM YYYY');

    // On déclenche l'action Redux editTask
    if (typeof editTask === 'function') {
      editTask(
        task,
        task.task,
        task.priority,
        task.priority,
        task.priorityColor,
        task.priorityColor,
        task.category,
        task.category,
        task.categoryColor,
        task.categoryColor,
        task.detail,
        task.detail,
        task.rdvDate,       // Ancienne date
        tomorrowFrenchText, // Nouvelle date (Texte français propre pour le calendrier)
        task.rdvTime,
        task.rdvTime,
        task.isRecurrent || false,   // 🚀 AJOUT RECURRENCE
        task.recurrenceType || '',
        task.lastResetMonth || '',
        task.location || ''
      );
    }

    // Mise à jour de sécurité directe dans Firestore
    db.collection('tasks')
      .doc(task.id)
      .update({
        rdvDate: tomorrowFrenchText,
        checked: false,
        autoClosed: false,
        completedAt: null,
        location: task.location || ''
      })
      .then(async () => {
        console.log(`La tâche "${task.task}" a bien été décalée au lendemain.`);
        // / 🎯 2. INCÉMENTATION DU COMPTEUR DE PROCRASTINATION DE L'UTILISATEUR
        if (task.authorId) { // On s'assure qu'on a bien l'ID de l'auteur de la tâche
          try {
            // Import dynamique de firebase si nécessaire selon votre fichier config,
            // ou utilisation directe via l'instance importée.
            await db.collection('users').doc(task.authorId).update({
              procrastinationCount: firebase.firestore.FieldValue.increment(1)
            });
            console.log("Compteur de procrastination mis à jour : +1");
          } catch (userErr) {
            console.error("Erreur mise à jour compteur utilisateur :", userErr);
          }
        }
        // 🎯 1. ON AFFICHE LE MESSAGE DE SUCCÈS
        setShowToast(true);
        handleClose();
      })
      .catch((err) => {
        console.error("Erreur lors du report automatique :", err);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 🚀 SÉCURISATION AVEC MOMENT.JS : On force le formatage en texte brut ISO
    // Si state.rdvDate est un objet moment, on le transforme en chaîne "YYYY-MM-DDTHH:mm", sinon on garde la valeur brute
    const rdvDateNettoyee = state.rdvDate && moment.isMoment(state.rdvDate)
      ? state.rdvDate.format('YYYY-MM-DDTHH:mm')
      : state.rdvDate;

    // Même chose pour l'heure : on s'assure qu'elle est au format "HH:mm"
    const rdvTimeNettoye = state.rdvTime && moment.isMoment(state.rdvTime)
      ? state.rdvTime.format('HH:mm')
      : state.rdvTime;
    // Si le switch de récurrence est activé (state.isRecurrent est vrai), 
    // on FORCE le statut à false (Active) pour qu'elle ne parte pas dans les terminées !
    const nouveauStatutChecked = state.isRecurrent ? false : task.checked;

    // 2. 🚀 APPEL UNIFIÉ : On envoie absolument toutes les données à editTask
    editTask(
      task,
      state.task,
      priority,
      state.priority,
      priorityColor,
      state.priorityColor,
      category,
      state.category,
      categoryColor,
      state.categoryColor,
      detail,
      state.detail,
      rdvDate,
      rdvDateNettoyee,
      // state.rdvDate,
      rdvTime,
      rdvTimeNettoye,
      // state.rdvTime,
      state.isRecurrent,
      state.recurrenceType,
      state.lastResetMonth,
      nouveauStatutChecked,
      false, // Écrase autoClosed à false
      false,  // Écrase touchedByUser à false
      task.location,
      state.taskLocation
    );

    toggleEditState();
    setShow(false);
    // handleClose();
  };

  const handleChangeOptionsPriority = (e) => {
    const { name, value } = e.target;
    const idx = e.target.selectedIndex;
    const optionElement = e.target.childNodes[idx];
    const priorityColor = optionElement.getAttribute('data-color');
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
        priorityColor: priorityColor
      };
    });
    setDisable(false);
  };

  const handleChangeOptionsCategory = (e) => {
    const { name, value } = e.target;
    const idx = e.target.selectedIndex;
    const optionElement = e.target.childNodes[idx];
    const categoryColor = optionElement.getAttribute('data-color');
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
        categoryColor: categoryColor
      };
    });
    setDisable(false);
  };

  const changeViewCalendar = (e) => {
    const rawValue = e.target.value;

    if (!rawValue) {
      setState((prev) => ({ ...prev, rdvDate: 'Aucun', rdvTime: '' }));
      return;
    }
    const [, timePart] = rawValue.split('T');

    setState((prev) => {
      return {
        ...prev,
        rdvDate: rawValue,
        rdvTime: timePart || '12:00'
      };
    });
    setDisable(false);
  };

  const handleColorChangeBox = (color) => {
    if (boxesRef.current) {
      boxesRef.current.style.backgroundColor = color;
    }
    setState((prev) => {
      return {
        ...prev,
        boxColorBcg: color
      };
    });
    setDisable(false);
  };

  const handleColorChangeBoxTitle = (color) => {
    if (titlesRef.current) {
      titlesRef.current.style.color = color;
    }
    setState((prev) => {
      return {
        ...prev,
        boxTitleColor: color
      };
    });
    setDisable(false);
  };

  const handleColorChangePickerBackground = (e) => {
    const color = e;
    const modalElement = document.querySelector('.modal-content');
    const modalColorBcg = (modalElement.style.backgroundColor = color);
    setState((prev) => {
      return {
        ...prev,
        modalColorBcg: modalColorBcg
      };
    });
    setDisable(true);
    setIsColorChanged(true);
  };

  const handleColorChangePickerTitle = (e) => {
    const color = e;
    const modalElementTitle = document.querySelector('.modal-title');
    const modalColorTitle = (modalElementTitle.style.color = color);
    setState((prev) => {
      return {
        ...prev,
        modalColorTitle: modalColorTitle
      };
    });
    setDisable(true);
    setIsColorChanged(true);
  };

  const handleColorChangePickerParagraphe = (e) => {
    const color = e;
    const modalElementPara = document.querySelector('.modal-body .paragraphe');
    const modalColorPara = (modalElementPara.style.color = color);
    setState((prev) => {
      return {
        ...prev,
        modalColorPara: modalColorPara
      };
    });
    setDisable(true);
    setIsColorChanged(true);
  };

  const handleColorChangePickerSpan = (e) => {
    const color = e;
    const modalElementSpan = document.querySelector('.modal-body span.resp');
    const modalColorSpan = (modalElementSpan.style.color = color);
    setState((prev) => {
      return {
        ...prev,
        modalColorSpan: modalColorSpan
      };
    });
    setDisable(true);
    setIsColorChanged(true);
  };

  const handleColorChangePickerStatutRep = (e) => {
    const color = e;
    const modalElementStatutRep = document.querySelector(
      '.modal-body span.statut-rep'
    );

    const modalColorStatutRep = (modalElementStatutRep.style.color = color);
    setState((prev) => {
      return {
        ...prev,
        modalColorStatutRep: modalColorStatutRep
      };
    });
    setDisable(true);
    setIsColorChanged(true);
  };

  const handleResetColorPickerBoxBcg = () => {
    setState((prev) => {
      return {
        ...prev,
        boxColorBcg: task.boxColorBcg ? task.boxColorBcg : colorBoxBcg
      };
    });
    setShowColorTask(false);
    setDisable(true);
  };

  const handleResetColorPickerBoxTitle = () => {
    setState((prev) => {
      return {
        ...prev,
        boxTitleColor: task.boxTitleColor ? task.boxTitleColor : colorBoxTitle
      };
    });
    setShowColorTaskTitle(false);
    setDisable(true);
  };

  const handleResetColorPickerBcg = () => {
    setState((prev) => {
      return {
        ...prev,
        modalColorBcg: task.modalColorBcg ? task.modalColorBcg : colorBcg
      };
    });
    setIsColorChanged(false);
  };

  const handleResetColorPickerTitle = () => {
    setState((prev) => {
      return {
        ...prev,
        modalColorTitle: task.modalColorTitle
          ? task.modalColorTitle
          : colorTitle
      };
    });
    setIsColorChanged(false);
  };

  const handleResetColorPickerPara = () => {
    setState((prev) => {
      return {
        ...prev,
        modalColorPara: task.modalColorPara ? task.modalColorPara : colorPara
      };
    });
    setIsColorChanged(false);
  };

  const handleResetColorPickerSpan = () => {
    setState((prev) => {
      return {
        ...prev,
        modalColorSpan: task.modalColorSpan ? task.modalColorSpan : colorSpan
      };
    });
    setIsColorChanged(false);
  };

  const handleResetColorPickerStatutRep = () => {
    setState((prev) => {
      return {
        ...prev,
        modalColorStatutRep: task.modalColorStatutRep
          ? task.modalColorStatutRep
          : colorStatutRep
      };
    });
    setIsColorChanged(false);
  };

  // 🎯 Ajoutez cette fonction pour convertir "2026-09-14T14:30" en "lundi 14 septembre 2026 à 14:30"
  const formatFrenchDate = (dateInput) => {
    if (!dateInput) return "Date non spécifiée";

    try {
      let dateObj;

      // 🎯 1. Si c'est un Timestamp Firebase (contient une fonction toDate)
      if (dateInput && typeof dateInput.toDate === 'function') {
        dateObj = dateInput.toDate();
      }
      // 🎯 2. Si c'est une chaîne de caractères (String)
      else if (typeof dateInput === 'string') {
        if (dateInput.toLowerCase().trim() === 'aucun') {
          return "Aucun rendez-vous";
        }
        dateObj = new Date(dateInput);
      }
      // 🎯 3. Pour tout autre format (ex: un objet Date natif)
      else {
        dateObj = new Date(dateInput);
      }

      // Sécurité si l'objet Date généré est invalide
      if (isNaN(dateObj.getTime())) {
        return "Date non spécifiée";
      }

      // Extrait le jour en joli français : "mardi 15 septembre 2026"
      const dateStr = dateObj.toLocaleDateString('fr-FR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      return `${dateStr}`;
    } catch (e) {
      console.error("Erreur formatFrenchDate:", e);
      return "Date non spécifiée";
    }
  };

  // 🎯 Calcul des badges "AUJOURD'HUI", ETC... en temps réel à l'intérieur de la carte
  // 🚀 1. HORLOGE ET SÉCURITÉ MOBILE
  const now = currentTime ? moment(currentTime) : moment();
  let isCardToday = false;
  let isCardTimeOver = false;
  let isBientôt = false;
  let isTomorrow = false;
  let isComming = false;

  // On s'assure que la date existe et est bien textuelle
  if (task?.rdvDate && typeof task.rdvDate === 'string' && task.rdvDate.toLowerCase().trim() !== 'aucun') {
    let rdvMoment = null;

    try {
      // Analyse propre et tolérante du format long français
      const estFormatLong = task.rdvDate.includes(' ');
      const baseDateStr = estFormatLong
        ? moment(task.rdvDate.trim(), 'dddd D MMMM YYYY', 'fr').format('YYYY-MM-DD')
        : task.rdvDate;

      if (task.rdvTime && typeof task.rdvTime === 'string' && task.rdvTime.trim() !== "" && task.rdvTime !== "Heure non spécifiée") {
        rdvMoment = moment(`${baseDateStr} ${task.rdvTime.trim()}`, 'YYYY-MM-DD HH:mm');
      } else {
        rdvMoment = moment(baseDateStr, 'YYYY-MM-DD').endOf('day');
      }

      // 🚀 2. VERIFICATION DE LA VALIDITÉ POUR ÉVITER LE CRASH SUR COMPOSANT MOBILE
      if (rdvMoment && rdvMoment.isValid()) {
        isCardToday = rdvMoment.isSame(now, 'day');
        isCardTimeOver = now.isAfter(rdvMoment);

        const minsRemaining = rdvMoment.diff(now, 'minutes');

        // On s'assure que minsRemaining est un nombre valide avant de comparer
        if (!isNaN(minsRemaining)) {
          isBientôt = isCardToday && !isCardTimeOver && minsRemaining <= 5 && minsRemaining >= 0;
          isTomorrow = rdvMoment.isSame(moment(now).add(1, 'day'), 'day') && !isCardTimeOver;
          isComming = rdvMoment.isAfter(moment(now).add(1, 'day'), 'day') && !isCardTimeOver;
        }
      }
    } catch (error) {
      console.error("Erreur de parsing de date interceptée pour éviter le crash mobile:", error);
    }
  }

  const cardClasses = ["box-text", "mb-3"];
  if (isCardToday && !isCardTimeOver && !task.checked) {
    cardClasses.push("border", "border-warning", "animate-pulse-subtle");
  } else {
    cardClasses.push("border-0");
  }

  return (
    <React.Fragment>
      {shouldMount && (
        <div className='box-body appear-fade'
          style={{
            transition: 'all .5s ease-in-out',
            opacity: stage === 'enter' ? 1 : 0,
            transform: {
              from: 'translateX(100%) rotate(90deg) scale(1.2)',
              enter: 'translateX(0%) rotate(0deg) scale(1)',
              leave: 'translateX(0%) rotate(0deg) scale(1)'
            }[stage] || 'translateX(0%) rotate(0deg) scale(1)'
          }}
        >
          <Card
            ref={boxesRef}
            className={cardClasses.join(" ")}
            style={{
              backgroundColor: state.boxColorBcg,
              borderWidth: (isCardToday && !isCardTimeOver && !task.checked) ? '2px' : '0px',
              opacity: task.checked ? 0.8 : 1,
              transition: '.5s',
            }}
          >

            <span className='anim top'></span>
            <span className='anim right'></span>
            <span className='anim bottom'></span>
            <span className='anim left'></span>

            {/* 🚀 BADGE DE RÉCURRENCE VISIBLE SUR LA CARTE */}
            <div className="d-flex justify-content-center mb-1">
              {task.isRecurrent ? (
                <React.Fragment>
                  <Badge bg="dark" className="text-warning border border-2 border-light fw-semibold py-1 mb-2" style={{ fontSize: '14px', letterSpacing: '0.3px' }}>
                    {(() => {
                      // 1. Récupération de la chaîne de récurrence (priorité à task, secours sur state)
                      const recType = task?.recurrenceType || state?.recurrenceType;
                      const isRec = task?.isRecurrent || state?.isRecurrent;

                      // 2. Si la récurrence est active et possède le bon format (ex: "monthly_5")
                      if (isRec && typeof recType === 'string' && recType.includes('_') && recType !== 'Aucune') {
                        const jourDuMois = recType.split('_')[1]; // 🚀 Extrait directement le chiffre (5, 10, etc.)
                        return `🔄 Tous les ${jourDuMois} du mois`;
                      }

                      // 3. Unique point de sortie si aucune condition n'est respectée
                      return <span className="text-light opacity-75">❌ Aucune récurrence</span>;
                    })()}
                  </Badge>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <Badge bg="dark" className="text-warning border border-2 border-light fw-semibold py-1 mb-2" style={{ fontSize: '14px', letterSpacing: '0.3px' }}>
                      <span className="text-light opacity-75">❌ Aucune récurrence</span>
                    </Badge>
                  </React.Fragment>
                )}
            </div>

            <Card.Title className='box-title mb-0' ref={titlesRef} style={{ color: state.boxTitleColor }}>Action:</Card.Title>
            <Card.Text className={`${task.checked ? 'checked' : ''} text mb-0`}>
              {task.task}
            </Card.Text>

            <Card.Title className='box-title mb-0' style={{ color: state.boxTitleColor }}>Commentaire:</Card.Title>
            <Card.Text
              className={task.checked ? 'checked text mb-0' : 'text mb-0'}>
              {state.detail}
            </Card.Text>

            <Card.Title className='box-title mb-0' style={{ color: state.boxTitleColor }}>Ajouté le:</Card.Title>
            <Card.Text className={task.checked ? 'checked text mb-0' : 'text mb-0'}>
              {moment(task.date.toDate()).format('dddd DD MMMM YYYY')}
            </Card.Text>

            <Card.Title className='box-title mb-0' style={{ color: state.boxTitleColor }}>Priorité:</Card.Title>
            <Card.Text
              className={task.checked ? 'checked text mb-0' : 'text mb-0'}
              style={{ color: task ? task.priorityColor : state.priorityColor }}
            >
              {task.priority}
            </Card.Text>

            <Card.Title className='box-title mb-0' style={{ color: state.boxTitleColor }}>Catégorie:</Card.Title>
            <Card.Text
              className={task.checked ? 'checked text mb-0' : 'text mb-0'}
              style={{ color: task ? task.categoryColor : state.categoryColor }}
            >
              {task.category}
            </Card.Text>

            <Card.Title className='box-title mb-0' style={{ color: state.boxTitleColor }}>Lieu:</Card.Title>
            <Card.Text
              className={task.checked ? 'checked text' : 'text'}
            >
              {task.location ? task.location : 'Non renseignée'} 
            </Card.Text>

            {task.checked ? (
              <React.Fragment>
                <Card.Title className='box-title mb-1' style={{ color: state.boxTitleColor }}>
                  <span>📅</span>Action clôturée le:
                </Card.Title>
                <Card.Text className='text mb-1' style={{ cursor: 'pointer' }}>
                  {task.completedAt ? formatFrenchDate(task.completedAt) : 'Date inconnue'}
                </Card.Text>
                <Card.Title className='box-title mb-0' style={{ color: state.boxTitleColor }}>
                  <span>⏰</span> Heure:
                </Card.Title>
                <Card.Text className='text mb-0' style={{ cursor: 'pointer' }}>
                  {task.completedAt ? moment(task.completedAt.toDate()).format('HH:mm') : 'Date inconnue'}
                </Card.Text>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Card.Title className='box-title mb-1' style={{ color: state.boxTitleColor }}>
                  {task.rdvDate && task.rdvDate.toLowerCase().trim() !== 'aucun' ? '📅 Rendez-vous le:' : '📅 Aucun rendez-vous'}
                </Card.Title>

                {task.rdvDate && task.rdvDate.toLowerCase().trim() !== 'aucun' && (
                  <Card.Text className={task.checked ? 'checked text mb-1' : 'text mb-1'}>
                    {formatFrenchDate(task.rdvDate)}
                  </Card.Text>
                )}
                {task.rdvDate && task.rdvDate.toLowerCase().trim() !== 'aucun' && (
                  <React.Fragment>
                    <Card.Title className='box-title mb-1' style={{ color: state.boxTitleColor }}>
                      <span>⏰</span> Heure:
                  </Card.Title>
                    <Card.Text className={task.checked ? 'checked text mb-1' : 'text mb-1'}>
                      {task.rdvTime && task.rdvTime !== 'Heure non spécifiée' ? task.rdvTime : 'Non spécifiée'}
                    </Card.Text>
                   </React.Fragment>
                )}
              </React.Fragment>
            )}

            <Card.Text className="d-flex justify-content-center badge-today mt-4">
              {/* Scénario A : Zone critique des 5 dernières minutes ➔ Badge rouge clignotant */}
              {isBientôt && !task.checked && (
                <Badge bg="danger" className="text-light fw-semibold fs-6 p-2 w-50 animate-pulse shadow-sm">
                  <span>🔔</span> Bientôt !
                </Badge>
              )}

              {/* 🎯 Le badge s'affiche en direct si c'est aujourd'hui et pas encore dépassé/coché */}
              {isCardToday && !isCardTimeOver && !isBientôt && !task.checked && (
                <Badge bg="warning" className="text-dark fw-semibold fs-6 p-2 w-50 animate-pulse-today shadow-sm">
                  <span>🚨</span> Aujourd'hui
                </Badge>
              )}

              {/* 🎯 Le badge s'affiche en direct si c'est demain et pas encore dépassé/coché */}
              {isTomorrow && !task.checked && (
                <Badge bg="primary" className="text-light fw-semibold fs-6 p-2 w-50 animate-pulse-tomorrow shadow-sm">
                  <span>☀️</span> Demain
                </Badge>
              )}

              {/* 🎯 Le badge s'affiche en direct si c'est demain et pas encore dépassé/coché */}
              {isComming && !task.checked && (
                <Badge bg="primary" className="text-light fw-semibold fs-6 p-2 w-50 shadow-sm">
                  <span>🔮</span> A venir
                </Badge>
              )}

              {task.checked && (
                <Badge bg="success" className="text-light fw-semibold fs-6 p-2 w-50 shadow-sm">✓ Terminé</Badge>
              )}
            </Card.Text>

            <div className='icons d-flex justify-content-evenly align-items-center w-100 mb-2 px-2 responsive-tools-group'>
              <Form.Check
                type="checkbox"
                checked={task.checked || false}
                onChange={handleCheckToggle}
                className="mx-2"
                id={`check-${task.id}`}
              />

              <i
                className='material-icons text-danger mx-1'
                style={{ cursor: 'pointer' }}
                title='Supprimer'
                onClick={() => handleShowRemoveTask(task)}
              >
                delete
              </i>

              <i
                className='material-icons text-info mx-1'
                style={{ cursor: 'pointer' }}
                title='Editer'
                onClick={() => handleShow(task)}
              >
                edit
              </i>

              <i
                className='material-icons text-warning mx-1'
                style={{ cursor: 'pointer' }}
                title='Voir le résumé'
                onClick={() => handleShowTask(task)}
              >
                visibility
              </i>

              <i
                className='material-icons text-light mx-1'
                style={{ cursor: 'pointer' }}
                title='Editer la couleur de fond'
                onClick={() => handleChangeColorBox(task)}
              >
                color_lens
              </i>

              <i
                className='material-icons text-dark mx-1'
                style={{ cursor: 'pointer' }}
                title='Editer la couleur des titres'
                onClick={() => handleChangeColorTitle(task)}
              >
                brush
              </i>
            </div>
          </Card>
        </div>
      )}

      <Modal
        show={showColorTask}
        onHide={handleClose}
        keyboard={false}
        contentClassName="bg-dark text-white shadow-lg"
        centered
        backdrop={false} // 👈 Retire complètement le filtre opaque
        className="modal-fullscreen-sm-down"

      >
        {/* Modal : Couleur du Fond */}
        <Modal.Header closeButton closeVariant="white" className="border-secondary">
          <Modal.Title>Couleur de fond</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Form.Group>
            <Form.Label className="fs-5 mb-3">Choisissez la couleur de fond :</Form.Label>
            <Form.Control
              type="color"
              className="form-control form-control-color mx-auto mb-3"
              value={state.boxColorBcg} onChange={(e) => handleColorChangeBox(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className='col-lg-12 d-flex justify-content-end border-secondary border-1 pt-3'>
          <Button
            variant='warning'
            className='px-3 fw-semibold'
            onClick={() => handleResetColorPickerBoxBcg(task)}
          >
            Annuler
                </Button>
          <Button
            variant='success'
            className='px-3 fw-semibold'
            disabled={disable}
            onClick={() => handleValidationShut(task)}
          >
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showColorTaskTitle}
        onHide={handleClose}
        keyboard={false}
        contentClassName="bg-dark text-white shadow-lg"
        centered
        backdrop={false}
        className="modal-fullscreen-sm-down"
      >
        <Modal.Header closeButton closeVariant="white" className="border-secondary">
          <Modal.Title>Couleur des titres</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Form.Group>
            <Form.Label className="mb-3">Choisissez la couleur des titres :</Form.Label>
            <Form.Control
              type="color"
              className="form-control form-control-color mx-auto mb-3"
              value={state.boxTitleColor}
              onChange={(e) => handleColorChangeBoxTitle(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className='col-lg-12 d-flex justify-content-end border-secondary border-1 pt-3'>
          <Button
            variant='warning'
            className='px-3 fw-semibold'
            onClick={() => handleResetColorPickerBoxTitle(task)}
          >
            Annuler
            </Button>
          <Button
            variant='success'
            className='px-3 fw-semibold'
            disabled={disable}
            onClick={() => handleValidationShut(task)}
          >
            Enregistrer
            </Button>
        </Modal.Footer>
      </Modal>

      {/* Notification de succès pour le report */}
      <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999 }}>
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          className="bg-success text-white shadow"
        >
          <Toast.Body className="d-flex align-items-center gap-2">
            <i className="material-icons me-2" style={{ verticalAlign: 'middle' }}>
              check_circle
            </i>
            <span className="fw-medium">Tâche reportée avec succès !</span>
          </Toast.Body>
        </Toast>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        keyboard={false}
        contentClassName="bg-dark text-light border-secondary"
        backdrop='static'
        className="modal-fullscreen-sm-down"
      >
        <Form autoComplete='off' className='w-100 responsive-select-wrapper' onSubmit={handleSubmit}>
          <Modal.Header closeButton closeVariant="white">
            <Modal.Title className="text-light fw-semibold">Mise à jour de l'action</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ maxHeight: '90vh', overflowY: 'auto', paddingBottom: '10px' }}>
            <Form.Group controlId='task' className="mb-2">
              <Form.Control
                type='text'
                name='task'
                className='input-update mt-2'
                required
                maxLength={limite}
                value={state.task}
                onChange={handleChange}
              />
              <Form.Control
                type='text'
                name='detail'
                className='input-update mt-3'
                maxLength={limite}
                onChange={handleChangeDetail}
                value={state.detail}
                placeholder="Ajouter un commentaire..."
              />

              <div className='border-rad mt-3'>
                <select
                  name='priority'
                  id="priority"
                  onChange={handleChangeOptionsPriority}
                  value={state.priority}
                  className='form-select form-select-sm'
                  aria-label='Default select example'
                >
                  <option disabled>Changer la priorité</option>
                  <option data-color={'#56d21a'} value={'Aucune'}>
                    Aucune priorité
                    </option>
                  <option data-color={'#f3e506'} value={'Importante'}>
                    Importante
                    </option>
                  <option data-color={'#ff0000'} value={'Urgente'}>
                    Urgente
                    </option>
                </select>
                <select
                  name='category'
                  id="category"
                  onChange={handleChangeOptionsCategory}
                  value={state.category}
                  className='form-select form-select-sm mt-3'
                  aria-label='Default select example'
                >
                  <option disabled>Changer la catégorie</option>
                  <option data-color={'#56d21a'} value={'Aucune'}>
                    Aucune catégorie
                    </option>
                  <option data-color={'#53cabc'} value={'Achat'}>
                    <span>💳</span> Achat
                    </option>
                  <option data-color={'#f057e2'} value={'Administratif'}>
                    <span>📁</span> Administratif
                    </option>
                  <option data-color={'#f2b0ef'} value={'Alimentation'}>
                    <span>🍏</span> Alimentation
                    </option>
                  <option data-color={'#f20202'} value={'Anniversaire'}>
                    <span>🎁</span> Anniversaire
                    </option>
                  <option data-color={'#abcdef'} value={'Automobile'}>
                    <span>🚗</span> Automobile
                    </option>
                  <option data-color={'#dce5e4'} value={'Banque'}>
                    <span>🏦</span> Banque
                    </option>
                  <option data-color={'#b78af4'} value={'Bien-être'}>
                    <span>🧘‍</span> Bien-être
                    </option>
                  <option data-color={'#f1573d'} value={'Bricolage'}>
                    <span>🪚</span> Bricolage
                    </option>
                  <option data-color={'#a9f5bc'} value={'Budget'}>
                    <span>💰</span> Budget
                    </option>
                  <option data-color={'#459AB1'} value={'Courses'}>
                    <span>🛒</span> Courses
                    </option>
                  <option data-color={'#9898e1'} value={'Facture'}>
                    <span>🧾</span> Facture
                    </option>
                  <option data-color={'#0fadc2'} value={'Famille'}>
                    <span>👨‍👩‍👧‍👦 </span> Famille
                    </option>
                  <option data-color={'#b1ff1e'} value={'Jardinage'}>
                    <span>🪴</span> Jardinage
                    </option>
                  <option data-color={'#f4c16e'} value={'Loisirs'}>
                    <span>🎨</span> Loisirs
                    </option>
                  <option data-color={'#f78181'} value={'Maison'}>
                    <span>🏠</span> Maison
                    </option>
                  <option data-color={'#1fd15d'} value={'Médical'}>
                    <span>🩺</span> Médical
                    </option>
                  <option data-color={'#fe2e64'} value={'Personnel'}>
                    <span>👤</span> Personnel
                    </option>
                  <option data-color={'#ffffff'} value={'Professionnel'}>
                    <span>💼</span> Professionnel
                    </option>
                  <option data-color={'#269255'} value={'Scolaire'}>
                    <span>🎓</span> Scolaire
                    </option>
                  <option data-color={'#0ff5e7'} value={'Sport'}>
                    <span>🏃‍</span> Sport
                    </option>
                  <option data-color={'#ff8000'} value={'Travail'}>
                    <span>🤝</span> Travail
                    </option>
                </select>


                {/* 🚀 COMMUTATEUR DE RÉCURRENCE DANS LA MODALE D'ÉDITION */}
                <div className="form-control input-update p-2 mt-3 responsive-switch-container">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <Form.Label htmlFor="recurrentCheck" className="text-light mb-0 fw-semibold" style={{ boxSizing: 'border-box', cursor: 'pointer' }}>
                      🔄 Tâche mensuelle récurrente
                      </Form.Label>
                    <Form.Check
                      type="switch"
                      id="recurrentCheck"
                      /* On lie la case à cocher à notre state d'édition */
                      checked={state.isRecurrent || false}
                      onChange={(e) => {
                        const isChecked = e.target.checked; // 🚀 Vrai ou Faux selon le clic

                        if (isChecked) {
                          // 1. Logique intelligente pour le jour 5 par défaut
                          const jourCible = 5;
                          const jourAujourdHui = moment().date(); // Nous sommes le 8

                          let dateRdvCible;
                          let verrouMois;

                          if (jourCible < jourAujourdHui) {
                            // 📅 Si le 5 est passé, on vise le 5 du mois PROCHAIN (Novembre)
                            dateRdvCible = moment().add(1, 'month').date(jourCible).format('YYYY-MM-DD');
                            verrouMois = moment().add(1, 'month').format('MM'); // "11"
                          } else {
                            // 📅 Si le 5 est futur, on reste sur ce mois-ci (Octobre)
                            dateRdvCible = moment().date(jourCible).format('YYYY-MM-DD');
                            verrouMois = moment().format('MM'); // "10"
                          }

                          setState({
                            ...state,
                            isRecurrent: true,
                            // recurrenceType: `monthly_${jourCible}`,
                            recurrenceType: 'recurrence',
                            rdvDate: dateRdvCible,
                            lastResetMonth: verrouMois,
                            checked: false
                          });

                          setLocalRdvDate(dateRdvCible);

                        } else {
                          // 🔄 Si l'utilisateur DÉCOCHE la récurrence, on nettoie proprement les champs
                          setState({
                            ...state,
                            isRecurrent: false,
                            recurrenceType: '',
                            lastResetMonth: '',
                            rdvDate: task.rdvDate, // 🎯 Remet la date d'origine dans le state du formulaire
                            rdvTime: task.rdvTime,
                            checked: false
                          });
                        }

                        setDisable(true); // Désactive le bouton "Sauvegarder"
                        setLocalRdvDate(task.rdvDate || 'Aucun');
                        setLocalRdvTime(task.rdvTime || '12:00');
                      }}
                    />
                  </div>

                  {/* 🎯 NOUVEAU : Si c'est coché, on affiche le choix du jour ! */}
                  {state.isRecurrent && (
                    <Form.Select
                      size="sm"
                      className="mt-2 bg-light text-dark small"
                      value={state.recurrenceType}
                      onChange={(e) => {
                        const type = e.target.value; // ex: "monthly_10"
                        const jourCible = type === 'monthly_5' ? '05' : type === 'monthly_10' ? '10' : type === 'monthly_15' ? '15' : type === 'monthly_20' ? '20' : type === 'monthly_25' ? '25' : type === 'monthly_30' ? '30' : '05';
                        const jourAujourdHui = moment().date(); // Nous sommes le 8

                        let dateRdvCible;
                        let verrouMois;

                        // 2. 🚀 LA LOGIQUE INTELLIGENTE :
                        if (parseInt(jourCible, 10) < jourAujourdHui) {
                          // Si le jour est passé (ex: le 5 alors qu'on est le 8), on vise le 5 du MOIS PROCHAIN (Novembre) !
                          dateRdvCible = moment().add(1, 'month').date(parseInt(jourCible, 10)).format('YYYY-MM-DD');
                          verrouMois = moment().add(1, 'month').format('MM'); // Verrou calé sur le mois prochain ("11")
                        } else {
                          // Si le jour est futur (ex: le 10 ou le 15 alors qu'on est le 8), on reste sur le MOIS EN COURS (Octobre) !
                          dateRdvCible = moment().date(parseInt(jourCible, 10)).format('YYYY-MM-DD');
                          verrouMois = moment().format('MM'); // Verrou calé sur ce mois-ci ("10")
                        }

                        // 1. CAS PARTICULIER : L'utilisateur annule la récurrence
                        if (type === 'Aucune') {
                          setLocalRdvDate('Aucun');
                          setLocalRdvTime('12:00');

                          setState({
                            ...state,
                            isRecurrent: false, // 🚀 Désactive proprement le flag booléen
                            recurrenceType: 'Aucune',
                            rdvDate: 'Aucun',
                            lastResetMonth: '',
                            checked: false
                          });
                          setDisable(false);
                          return; // On arrête l'exécution ici
                        }

                        setState({
                          ...state,
                          recurrenceType: type,
                          rdvDate: dateRdvCible,
                          lastResetMonth: verrouMois, // Verrouille le bon mois de départ pour le robot
                          checked: false
                        });

                        setLocalRdvDate(dateRdvCible);
                        setDisable(false);
                      }}
                    >
                      <option disabled value="recurrence">Récurrence du mois</option>
                      <option value="Aucune">Aucune récurrence</option>
                      <option value="monthly_5">Le 5 de chaque mois</option>
                      <option value="monthly_10">Le 10 de chaque mois</option>
                      <option value="monthly_15">Le 15 de chaque mois</option>
                      <option value="monthly_20">Le 20 de chaque mois</option>
                      <option value="monthly_25">Le 25 de chaque mois</option>
                      <option value="monthly_30">Le 30 de chaque mois</option>
                    </Form.Select>
                  )}
                </div>


                <div className="form-control-plaintext mt-3 text-white mb-3 position-relative" style={{ overflow: 'visible' }}>
                  <Form.Label className="text-start text-light mb-2 w-100">📍 Rechercher un Lieu / Adresse</Form.Label>
                  <div className="input-group">
                    <span className="input-group-text bg-dark border-secondary text-info">
                      <i className="material-icons">place</i>
                    </span>
                    <Form.Control
                      type="text"
                      placeholder="Tapez une adresse... (ex: 10 Rue de la Paix)"
                      value={state.taskLocation || ''}
                      onChange={async (e) => {
                        const valeur = e.target.value;

                        // 1. Débloque instantanément la frappe dans la case de texte
                        setState(prev => ({
                          ...prev,
                          taskLocation: valeur
                        }));

                        // 2. 🚀 APPEL DIRECT ETALAB : Se déclenche dès que vous tapez plus de 2 lettres !
                        // Active l'autocomplétion d'Etalab
                        if (valeur && valeur.trim().length > 2) {
                          try {
                            // 🚀 RECONSTITUTION DE SÉCURITÉ : Évite le blocage et la coupure de l'URL
                            const domaineEtalab = 'api-adresse.data.gouv.fr';
                            const urlEtalab = 'https://' + domaineEtalab + '/search/?q=' + encodeURIComponent(valeur) + '&limit=5';
                            const response = await fetch(urlEtalab);
                            const data = await response.json();

                            // 🚀 MISE À JOUR DU TABLEAU DES SUGGESTIONS
                            if (data && data.features) {
                              setAdresseSuggestions(data.features);
                            } else {
                              setAdresseSuggestions([]);
                            }
                          } catch (error) {
                            console.error("Erreur API Adresse :", error);
                            setAdresseSuggestions([]);
                          }
                        } else {
                          setAdresseSuggestions([]);
                        }
                        setDisable(false);
                      }}
                      className="bg-dark text-light border-secondary"
                    />
                  </div>

                  {/* 🚀 LISTE DÉROULANTE DES SUGGESTIONS D'ADRESSES (S'affiche si des adresses sont trouvées) */}
                  {adresseSuggestions && adresseSuggestions.length > 0 && (
                    <div className="position-absolute w-100 shadow-lg mt-1" style={{
                      zIndex: 9999, maxHeight: '200px', borderRadius: '4px',
                      backgroundColor: '#343a40', overflowY: 'auto'
                    }}
                    >
                      <div className="list-group">
                        {adresseSuggestions.map((suggestion, index) => (
                          <button
                            key={index}
                            type="button"
                            className="list-group-item list-group-item-action bg-primary text-light border-dark py-2 text-start"
                            onClick={() => {
                              // Au clic, on injecte l'adresse officielle propre et on ferme la liste déroulante
                              setState(prevState => ({
                                ...prevState,
                                taskLocation: suggestion.properties.label
                              }));
                              setAdresseSuggestions([]);
                            }}
                          >
                            <small className="fw-semibold">📍 {suggestion.properties.label}</small>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>


                <div className="form-control-plaintext mt-3 text-white mb-2 position-relative" style={{ overflow: 'visible' }}>
                  {/* 🎯 Titre centré au milieu */}
                  <Form.Label className="text-light text-start w-100 mb-2">
                    🗓️ Modifier la Date / Heure
                    </Form.Label>

                  {/* 🟢 ALIGNEMENT CÔTE À CÔTE */}
                  <div className="d-flex flex-column flex-sm-row align-items-stretch gap-2 w-100 position-relative">

                    {/* 📅 DE BLOC DATE */}
                    <div className="flex-grow-1 position-relative" style={{ minWidth: '140px' }}>
                      <Form.Control
                        type="text"
                        className="text-white bg-input-modale border-secondary"
                        placeholder="📅 Cliquez pour choisir un jour..."
                        value={localRdvDate && localRdvDate !== 'Aucun' ? formatFrenchDate(localRdvDate) : ''}
                        onClick={() => {
                          setShowCalendar(true);
                        }}
                        readOnly
                        style={{ cursor: 'pointer' }}
                      />

                      {/* 🎯 POP-UP CALENDRIER RE-BRANCHÉ SUR LES INFOS DE LA TÂCHE ACTUELLE */}
                      {showCalendar && (
                        <div
                          className="position-absolute shadow-lg p-2 rounded border border-secondary bg-input-modale responsive-calendar-popup"
                          style={{
                            top: '100%',
                            left: 0,
                            width: '320px',
                            marginTop: '5px',
                            zIndex: 99999
                          }}
                        >
                          <Calendar
                            locale="fr-FR"
                            formatMonthYear={capitaliserMois}
                            value={localRdvDate && localRdvDate !== 'Aucun' ? moment(localRdvDate, ['YYYY-MM-DD', 'dddd D MMMM YYYY'], 'fr').toDate()
                              : new Date()
                            }
                            formatShortWeekday={(locale, date) =>
                              date.toLocaleDateString(locale, { weekday: 'short' }).toUpperCase()
                            }
                            onChange={(selectedDate) => {
                              const dateUniquement = moment(selectedDate).format('YYYY-MM-DD');
                              const heureActuelle = localRdvTime && localRdvTime.trim() !== "" ? localRdvTime.slice(0, 5) : "12:00";

                              setLocalRdvDate(dateUniquement);
                              setIsCalendarClosed(false);

                              // 🎯 Met à jour directement la tâche en cours
                              const syntheticEvent = {
                                target: { value: `${dateUniquement}T${heureActuelle}` }
                              };
                              changeViewCalendar(syntheticEvent);
                              setShowCalendar(false);
                            }}
                          />
                          <button
                            className="btn btn-sm btn-primary w-100 mt-2 text-white"
                            onClick={() => {
                              setShowCalendar(false);
                              setIsCalendarClosed(true);
                            }}
                          >
                            Fermer
                            </button>
                        </div>
                      )}
                    </div>

                    {/* ⏰ BLOC HEURE (Affiché si une date existe OU si le calendrier est en cours de choix) */}
                    {((localRdvDate && localRdvDate !== 'Aucun') || showCalendar) && (
                      <div className="d-flex flex-row align-items-center gap-2" style={{ minWidth: '120px' }}>
                        <Form.Control
                          type="time"
                          step="300"
                          className="text-white bg-input-modale border-secondary"
                          value={localRdvTime}
                          onChange={(e) => {
                            const nouvelleHeure = e.target.value.slice(0, 5);
                            const dateNettoyee = localRdvDate ? localRdvDate.split('T')[0] : moment().format('YYYY-MM-DD');

                            setLocalRdvTime(nouvelleHeure);

                            const syntheticEvent = {
                              target: { value: `${dateNettoyee}T${nouvelleHeure}` }
                            };
                            changeViewCalendar(syntheticEvent);
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {/* 🟢 BOUTON EFFACER LE RDV (S'affiche uniquement s'il y a un rendez-vous actif) */}
                  {!showCalendar && !isCalendarClosed && (
                    <div className="d-flex flex-row justify-content-center align-items-center gap-2 w-100 mt-3">

                      {localRdvDate && localRdvDate !== 'Aucun' && (
                        <Button
                          variant="outline-warning"
                          size="sm"
                          className="d-flex align-items-center gap-1 mt-1 "
                          style={{ fontSize: '0.8rem', fontWeight: '500' }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            setLocalRdvDate('Aucun');
                            setLocalRdvTime('12:00');

                            if (typeof setDisable === 'function') setDisable(false);

                            const syntheticEvent = {
                              target: { value: '' }
                            };
                            changeViewCalendar(syntheticEvent);
                          }}
                        >
                          <i className="material-icons" style={{ fontSize: '16px', color: 'inherit' }}>clear</i>
                          Effacer le rendez-vous
                          </Button>
                      )}
                    </div>
                  )}

                  {/* Rendu de la confirmation orange mis à jour en direct */}
                  {localRdvDate && localRdvDate !== 'Aucun' && (
                    <div className="text-warning text-center mt-2 w-100">
                      📅 <span className="text-light">Planifié le :</span>
                      <div>{formatFrenchDate(localRdvDate)} à {localRdvTime}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className="d-flex flex-column justify-content-between align-items-stretch align-items-sm-center gap-2 border-secondary border-1 pt-2 w-100 responsive-btn-group">
                <Button
                  type='submit'
                  variant={disable ? 'warning' : 'primary'}
                  disabled={disable}
                  className="d-flex align-items-center justify-content-center px-3 mb-1 fw-semibold w-100"
                >
                  {disable ? (
                    <React.Fragment>
                      <i className="material-icons align-middle mx-1" style={{ fontSize: '19px' }}>lock</i>
                      Inchangé
                      </React.Fragment>
                  ) : (
                      <React.Fragment>
                        <i className="material-icons align-middle me-1" style={{ fontSize: '19px' }}>save</i>
                        Sauvegarder
                    </React.Fragment>
                    )}
                </Button>

                <Button
                  type='button'
                  variant='primary'
                  onClick={handleClose}
                  className="d-flex align-items-center justify-content-center px-3 fw-semibold w-100"
                >
                  Fermer
                  </Button>
              </div>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer className="d-flex flex-column justify-content-between align-items-stretch align-items-sm-center border-secondary border-1 pt-2 w-100 responsive-btn-group">
            <Button
              type='button'
              variant="outline-warning"
              className="d-flex align-items-center justify-content-center w-100 flex-grow-1 flex-sm-grow-0"
              onClick={handleReportToTomorrow}
            >
              <i className="material-icons align-middle fw-semibold mx-1" style={{ fontSize: '19px' }}>hourglass_top</i>
              Reporter
                  </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showTask} centered size='lg'>
        <div
          className='modal-content custom-memento-modal'
          style={{
            borderColor: '#fff',
            backgroundColor: `${state.modalColorBcg}`
          }}
        >
          <Modal.Header
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Modal.Title
              className='modal-title'
              style={{
                fontSize: '2.2rem',
                color: `${state.modalColorTitle}`
              }}
            >
              MEMENTO
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className='p-3 p-sm-4'>
            <div className='col-lg-12 px-sm-1'>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Objet:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {task.task}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Commentaire:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {task.detail}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Rendez-vous le:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {!task.checked && task.rdvDate
                    ? formatFrenchDate(task.rdvDate)
                    : task.rdvDate === 'Aucun'
                      ? 'Aucun'
                      : 'Terminé'}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Heure du rendez-vous:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {!task.checked && task.rdvTime
                    ? `${task.rdvTime}`
                    : !task.rdvTime
                      ? 'Aucune'
                      : 'Terminée'}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Catégorie de l'action:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {task.category}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Priorité de l'action:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {task.priority}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Récurrence de l'action:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {task.isRecurrent && task.recurrenceType && typeof task.recurrenceType === 'string' && task.recurrenceType.includes('_') ? (
                    <span className="text-warning fw-semibold">
                      Tous les {task.recurrenceType.split('_')[1]} du mois
                  </span>
                  ) : (
                      <span className="text-warning fw-semibold">
                        <em className="text-light fw-normal">Aucune</em>
                      </span>
                    )}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Lieu du rendez-vous:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {!task.checked ? (
                    task.location || <em className="text-light fw-normal">Non renseignée</em>
                  ) : (
                      'Aucune'
                    )}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Ajouté le:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {/* {moment(task.date.toDate()).calendar('dddd DD MMMM YYYY')} &ensp; ( */}
                  {moment(task.date.toDate()).format('dddd DD MMMM YYYY à HH:mm')}

                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                Statut de l'action:
                <span
                  className='statut-rep fw-semibold'
                  style={{
                    color: state.modalColorStatutRep
                  }}
                >
                  {' '}
                  {task.checked ? 'Terminée' : 'En cours...'}
                </span>
              </p>
              <p
                className='paragraphe'
                style={{
                  color: state.modalColorPara
                }}
              >
                {' '}
                Action clôturée le:{' '}
                <span
                  className='resp fw-semibold'
                  style={{
                    color: state.modalColorSpan
                  }}
                >
                  {task.checked
                    ? moment(
                      task.completedAt && task.completedAt.toDate()
                    ).format('dddd DD MMMM YYYY à HH:mm')
                    : ''}
                </span>
              </p>
            </div>

            <div className='d-flex flex-column gap-3 picker-panel w-100'>
              <div className='d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between p-2 border-bottom pb-3 gap-2 gap-sm-0'>
                <div className='d-flex align-items-center gap-3'>
                  <Form.Label htmlFor='exampleColorInput' className='m-0 fw-semibold text-white'>
                    Couleur de Fond
                </Form.Label>
                  <Form.Control
                    type='color'
                    id='exampleColorInput'
                    className='form-control form-control-color border-0 flex-shrink-0'
                    value={state.modalColorBcg}
                    onChange={(e) =>
                      handleColorChangePickerBackground(e.target.value)
                    }
                    title='Choisis ta couleur'
                  />
                </div>

                <Button
                  size='sm'
                  type='submit'
                  variant='dark'
                  className='px-3 w-sm-auto'
                  disabled={!disable}
                  onClick={handleResetColorPickerBcg}
                >
                  Réinitialiser
                </Button>
              </div>

              <div className='d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between p-2 border-bottom pb-3 gap-2 gap-sm-0'>
                <div className='d-flex align-items-center gap-3'>
                  <Form.Label htmlFor='exampleColorInput2' className='m-0 fw-semibold text-white'>
                    Couleur du Titre
                </Form.Label>
                  <Form.Control
                    type='color'
                    id='exampleColorInput2'
                    className='form-control form-control-color border-0 flex-shrink-0'
                    value={state.modalColorTitle}
                    onChange={(e) => handleColorChangePickerTitle(e.target.value)}
                    title='Choisis ta couleur'
                  />
                </div>
                <Button
                  size='sm'
                  type='submit'
                  variant='dark'
                  className='px-3 w-sm-auto'
                  disabled={!disable}
                  onClick={handleResetColorPickerTitle}
                >
                  Réinitialiser
                </Button>
              </div>

              <div className='d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between p-2 border-bottom pb-3 gap-2 gap-sm-0'>
                <div className='d-flex align-items-center gap-3'>
                  <Form.Label htmlFor='exampleColorInput3' className='m-0 fw-semibold text-white'>
                    Couleur du Paragraphe
                </Form.Label>
                  <Form.Control
                    type='color'
                    id='exampleColorInput3'
                    className='form-control form-control-color border-0 flex-shrink-0'
                    value={state.modalColorPara}
                    onChange={(e) =>
                      handleColorChangePickerParagraphe(e.target.value)
                    }
                    title='Choisis ta couleur'
                  />
                </div>
                <Button
                  size='sm'
                  type='submit'
                  variant='dark'
                  className='px-3 w-sm-auto'
                  disabled={!disable}
                  onClick={handleResetColorPickerPara}
                >
                  Réinitialiser
                </Button>
              </div>

              <div className='d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between p-2 border-bottom pb-3 gap-2 gap-sm-0'>
                <div className='d-flex align-items-center gap-3'>
                  <Form.Label htmlFor='exampleColorInput4' className='m-0 fw-semibold text-white'>
                    Couleur de la Réponse
                </Form.Label>
                  <Form.Control
                    type='color'
                    id='exampleColorInput4'
                    className='form-control form-control-color border-0 flex-shrink-0'
                    value={state.modalColorSpan}
                    onChange={(e) => handleColorChangePickerSpan(e.target.value)}
                    title='Choisis ta couleur'
                  />
                </div>
                <Button
                  size='sm'
                  type='submit'
                  variant='dark'
                  className='px-3 w-sm-auto'
                  disabled={!disable}
                  onClick={handleResetColorPickerSpan}
                >
                  Réinitialiser
                </Button>
              </div>

              <div className='d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between p-2 border-bottom pb-3 gap-2 gap-sm-0'>
                <div className='d-flex align-items-center gap-3'>
                  <Form.Label htmlFor='exampleColorInput5' className='m-0 fw-semibold text-white'>
                    Couleur du Statut
                </Form.Label>
                  <Form.Control
                    type='color'
                    id='exampleColorInput5'
                    className='form-control form-control-color border-0 flex-shrink-0'
                    value={state.modalColorStatutRep}
                    onChange={(e) =>
                      handleColorChangePickerStatutRep(e.target.value)
                    }
                    title='Choisis ta couleur'
                  />
                </div>
                <Button
                  size='sm'
                  type='submit'
                  variant='dark'
                  className='px-3 w-sm-auto'
                  disabled={!disable}
                  onClick={handleResetColorPickerStatutRep}
                >
                  Réinitialiser
                </Button>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className='d-flex justify-content-end align-items-center'>
            <Button
              type='submit'
              variant='warning'
              className='px-3 fw-semibold'
              onClick={handleClose}
            >
              Fermer
              </Button>
            <Button
              type='submit'
              variant='success'
              className='px-3 fw-semibold'
              disabled={!isColorChanged}
              onClick={handleValidationShut}
            >
              Enregistrer
            </Button>

            {!task.checked ? null : (
              <React.Fragment>
                <p
                  className='mt-2 ms-2'
                  style={{
                    color: `${state.modalColorPara}`
                  }}
                >
                  <i className='material-icons'>
                    star
                  </i>
                  <i className='material-icons'>
                    star
                  </i>
                  <i className='material-icons'>
                    star
                  </i>
                  <i className='material-icons'>
                    star
                  </i>
                </p>
              </React.Fragment>
            )}
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showRemoveTask}
        onHide={handleClose}
        backdrop='static'
        centered
        keyboard={false}
      >
        <Modal.Header closeButton closeVariant="dark" className="border-secondary">
          <Modal.Title className="m-0 text-danger fw-semibold" style={{ fontSize: '1.2rem' }}>
            Suppression de l'action
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center fw-semibold p-2" style={{ fontSize: '1.1rem' }}>
          Voulez-vous supprimer cette action ?
        </Modal.Body>
        <Modal.Footer className='d-flex justify-content-end border-top-0 pt-3'>
          <Button
            variant='secondary'
            className='px-3 fw-semibold'
            onClick={handleClose}
          >
            Annuler
            </Button>
          <Button
            variant='danger'
            className='px-3 fw-semibold'
            onClick={() => handleRemoveTask(task)}
          >
            Supprimer
            </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeTask: (task) => dispatch(removeTask(task)),
    toggleChecked: (task, completionData) =>
      dispatch(toggleChecked(task, completionData)),
    addColorPicker: (task) => dispatch(addColorPicker(task)),
    editTask: (...args) => dispatch(editTask(...args))
  };
};

export default connect(null, mapDispatchToProps)(Task);